
export function getTeamParticipantEmails(teamParticipantDetails) {
    return teamParticipantDetails
        .filter(participant => participant.role !== 'Holdkaptajn')
        .filter(participant => participant.email)
        .map(participant => participant.email)
        .join(',')
}
